import { css } from 'styled-components';

/**
 * A visible keyboard-only focus ring shared by every category-card destination.
 *
 * The authored card background and border colors are theme-controlled, so the ring uses a dedicated
 * override token with the established Dutchie interaction blue as a high-contrast fallback. Keeping
 * this on the destination anchor means the ring follows the same hit target Enter activates.
 */
export const categoryCardFocusRing = css`
  &:focus-visible {
    outline: 3px solid var(--dcm-categories-card-focus-ring, #0b99e6);
    outline-offset: 3px;
  }
`;
